const configure = {
  // appUrl: "/",
  // apiUrl: "https://api.zithas.com/api",
  // imgUrl: "https://api.zithas.com/application/public",   // Live
  // nodeApi: 'https://napi.zithas.com/api',
  // nodeImgApi: 'https://napi.zithas.com',
  // nodeUkApi: "https://napi.zithas.co.uk/api",
  // glitzUrl:"https://ats.glitzzstaffing.com/api",
  // exchangeKey: "HBhbjhBY9Zui0q8XUT0O7BcuFgs9l5q5",
  // domain: "mars.zithas.in",
  // hostingDomainOnlyId: 14,

  // type: 2, // Earth

  // imgUrl: "https://mars.ztpl.net/application/public",
  // apiUrl: "https://mars.ztpl.net/api",                   // Ztpl

  appUrl: "/crm/",
  apiUrl: "https://edemoapi.zithas.com/api",
  imgUrl: "https://edemoapi.zithas.com/application/public",    // demo Ztpl
  nodeApi: 'https://endemoapi.zithas.com/api',
  nodeUkApi: "https://dnapi.zithas.co.uk/api",
  nodeImgApi: 'https://endemoapi.zithas.com',
  glitzUrl: 'https://demoetsd.usetalentflux88.com/api',
  exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG",
  domain: `edemo.zithas.com/crm`,
  hostingDomainOnlyId: 30,

  dashboardModule: 4
}

export default configure